module.exports = __webpack_public_path__ + "static/media/icon-setup-profile.47bcb613.svg";